
import Vue from 'vue'
export default Vue.extend({
    props:["title","subject","allowSubjectEdit","body","allowBodyEdit"],
    data(){
        return {
            userSearch:"",
            eventSearch:"",
            selectedUsers:[] as Array<any>,
            selectedLogs:[] as Array<any>,
            actualSubject:"",
            additionalInfo:"",
            selectedDepartments:[] as Array<string>,
            selectedOperationUnits:[] as Array<string>,
            selectedModels:[],
            activeScreen:"FORM",
            selectedDepartmentAll:true,
            selectUserAll:false,
            selectedDepartmentIndeterminate:false,
            selectedOperationUnitAll:true,
            selectedOperationUnitIndeterminate:false
        }
    },
    computed:{
        activeUser():any{
            return this.$store.getters["activeUser"]
        },
        users():any{
            return this.$store.getters["usersModule/fillteredUsers"](this.userSearch,-1)
        },
        filteredUsers():any{
            return this.users.filter((u:any) => !this.selectedUsers.some((su:any) => su.id==u.id) && this.selectedOperationUnits.some(t=>t==u.operationUnitId))
        },
        logs():any{
            return this.$store.getters['ApplicationLogModule/getLogs']
        },
        filterLog():any{
            return this.logs.filter((l:any) => l.fullName == this.activeUser.firstName+' '+this.activeUser.lastName).map((l:any) => ({...l,selected:this.selectedLogs.some((sl:any)=>sl.id==l.id)}))
        },
        reciepient():string{
            return this.selectedUsers.join(',')
        },
        actualBody():any{
            let concatenatedEvents = "\n"
            this.selectedLogs.forEach((l:any,index) => {
                concatenatedEvents = concatenatedEvents+"\n  "+(index+1)+'. '+l.description
            })
            return this.body+concatenatedEvents+"\n\n"+this.additionalInfo
        },
        departments():any{
            return this.$store.getters["departmentModule/getAllDepartments"]
        },
        operationUnits():any{
            const operationUnitsOptions = [] as Array<any>
            this.$store.getters["departmentModule/getAllDepartments"].filter((d:any) => this.selectedDepartments.some(sd=>sd==d.id)).forEach((d:any) => {
                operationUnitsOptions.push(...d.operationUnits.map((t:any) => ({id:t.id,name:t.name})))
            });
            return operationUnitsOptions;
        }
    },
    methods:{
        removeUser(userId:any){
            const userToRemoveIdex = this.selectedUsers.findIndex((u:any) => u.id == userId)
            if(userToRemoveIdex>-1) this.selectedUsers.splice(userToRemoveIdex,1)
        },
        onSelectedUserChanged(id:any,name:any,email:any){
            this.selectedUsers.unshift({id,name,email})
        },
        onSelectedEventChanged(id:any,description:any){
            const eventIndexToManipulate = this.selectedLogs.findIndex((l:any) => l.id == id)
            if(eventIndexToManipulate>-1){
                this.selectedLogs.splice(eventIndexToManipulate,1)
            }else{
                this.selectedLogs.push({id:id,description:description})
            }
        },
        broadcast(){
            this.activeScreen = "LOADING"
            this.$store.dispatch("sequencesModule/broadcast",{subject:this.actualSubject,body:this.actualBody.replace("\n","<p>").replace(/\n/gi,"</p><p>"),reciepients:this.selectedUsers.map((su:any) => su.email)}).then(() => {
                this.activeScreen = "SUCCESS"
            })
        },
        selectAllUsersClicked(){
            if(this.selectUserAll){
                this.selectUserAll = false
                this.selectedUsers.splice(0,this.selectedUsers.length)
            }else{
                this.selectUserAll = true
                this.filteredUsers.forEach((user:any) => {
                    if(!this.selectedUsers.some((su => su.id==user.id))) this.selectedUsers.push({id:user.id,name:user.firstName+' '+user.lastName,email:user.email})
                });
            }
        },
        selectedDeptChanged(deptId:any){
            let indexOfSelectedDept = this.selectedDepartments.findIndex((sd:any) => sd == deptId)
            const selectedDept = this.departments.find((d:any) => d.id == deptId)
            if(selectedDept){
                if(indexOfSelectedDept<0){
                    this.selectedOperationUnits.push(...selectedDept.operationUnits.map((t:any)=>t.id))
                }else{
                    const operationUnitsToRemove:Array<string> = selectedDept.operationUnits.map((t:any) => t.id)
                    const selectedOperationUnitCount = this.selectedOperationUnits.length
                    this.selectedOperationUnits.splice(0,selectedOperationUnitCount,...this.selectedOperationUnits.filter(t=>!operationUnitsToRemove.some((tr)=>tr==t)))
                }
            }
            this.updateDeptCheckAllState()
            this.updateOperationUnitsCheckAllState()
        },
        selectedOperationUnitsChanged(){
            this.updateOperationUnitsCheckAllState()
        },
        toggleAllDepts(state:Boolean){
            if(state){
                const elementsNotAdded = this.departments.filter((d:any) => !this.selectedDepartments.some((sd:string) => sd==d.id) )
                this.selectedDepartments.push(...elementsNotAdded.map((d:any) => d.id))
                elementsNotAdded.forEach((d:any) => {
                    this.selectedOperationUnits.push(...d.operationUnits.map((t:any) => t.id))
                });
            }else{
                this.selectedDepartments.splice(0,this.selectedDepartments.length)
                this.selectedOperationUnits.splice(0,this.selectedOperationUnits.length)
            }
            this.updateDeptCheckAllState()
            this.updateOperationUnitsCheckAllState()
        },
        toggleAllOperationUnits(state:Boolean){
            if(state){
                const elementsNotAdded = this.operationUnits.map((t:any) => t.id).filter( (t:string) => !this.selectedOperationUnits.some((st:string) => st==t) )
                this.selectedOperationUnits.push(...elementsNotAdded)
            }else{
                this.selectedOperationUnits.splice(0,this.selectedOperationUnits.length)
            }
            this.updateOperationUnitsCheckAllState()
        },
        updateDeptCheckAllState(){
            this.$nextTick(() => {
                if(this.selectedDepartments.length==0){
                    this.selectedDepartmentAll = false
                    this.selectedDepartmentIndeterminate = false
                }
                else if (this.selectedDepartments.length == this.departments.length) {
                    this.selectedDepartmentAll = true
                    this.selectedDepartmentIndeterminate = false
                }else{
                    this.selectedDepartmentIndeterminate = true;
                    this.selectedDepartmentAll = false
                }
            })
        },

        updateOperationUnitsCheckAllState(){
            this.$nextTick(() => {
                if(this.selectedOperationUnits.length==0){
                    this.selectedOperationUnitAll = false
                    this.selectedOperationUnitIndeterminate = false
                }
                else if (this.selectedOperationUnits.length == this.operationUnits.length) {
                    this.selectedOperationUnitAll = true
                    this.selectedOperationUnitIndeterminate = false
                }else{
                    this.selectedOperationUnitIndeterminate = true;
                    this.selectedOperationUnitAll = false
                }
            })
        }
    },
    mounted(){
        this.actualSubject = this.subject
        if(this.users.length==0)this.$store.dispatch("usersModule/getUsers")
        if(this.logs.length == 0)this.$store.dispatch("ApplicationLogModule/getApplicationLogs")
        if(this.departments.length == 0){
            this.$store.dispatch("departmentModule/getDepartments").then(() => {
                this.selectedDepartments = this.departments.map((d:any)=>d.id)
                this.departments.forEach((d:any) => {
                    this.selectedOperationUnits.push(...d.operationUnits.map((t:any)=>t.id))
                });
            })
        }else{
            this.selectedDepartments = this.departments.map((d:any)=>d.id)
            this.departments.forEach((d:any) => {
                this.selectedOperationUnits.push(...d.operationUnits.map((t:any)=>t.id))
            });
        }
    }
})
